import {
  ActionsUnion,
  ITeamMemberPermission,
  IUpdateTeamMemberPermissionDTO,
  ICreateTeamMemberPermissionDTO
} from '../../../types'
import { teamMemberPermissionService } from '../../../services/TeamMemberPermission'
import { createAction } from '../helpers'
import * as constants from '../../constants'

export type ITeamMemberPermissionAction = ActionsUnion<typeof actionCreators>

export const actionCreators = {
  fetchTeamMemberPermissionRequest: () => createAction(constants.TEAM_MEMBER_PERMISSION_FETCH_REQUEST),
  fetchTeamMemberPermissionSuccess: (payload: ITeamMemberPermission) =>
    createAction(constants.TEAM_MEMBER_PERMISSION_FETCH_SUCCESS, payload),
  fetchTeamMemberPermissionFail: (error: string) => createAction(constants.TEAM_MEMBER_PERMISSION_FETCH_FAIL, error),

  updateTeamMemberPermissionRequest: () => createAction(constants.TEAM_MEMBER_PERMISSION_UPDATE_REQUEST),
  updateTeamMemberPermissionSuccess: (payload: boolean) =>
    createAction(constants.TEAM_MEMBER_PERMISSION_UPDATE_SUCCESS, payload),
  updateTeamMemberPermissionFail: (error: string) => createAction(constants.TEAM_MEMBER_PERMISSION_UPDATE_FAIL, error),

  createTeamMemberPermissionRequest: () => createAction(constants.TEAM_MEMBER_PERMISSION_CREATE_REQUEST),
  createTeamMemberPermissionSuccess: (payload: ITeamMemberPermission) =>
    createAction(constants.TEAM_MEMBER_PERMISSION_CREATE_SUCCESS, payload),
  createTeamMemberPermissionFail: (error: string) => createAction(constants.TEAM_MEMBER_PERMISSION_CREATE_FAIL, error),
  setCurrentTeamMemberPermission: (permission: ITeamMemberPermission) =>
    createAction(constants.SET_CURRENT_TEAM_MEMBER_PERMISSION, permission)
}

export function fetchTeamMemberPermission(id: string) {
  const {
    fetchTeamMemberPermissionRequest,
    fetchTeamMemberPermissionSuccess,
    fetchTeamMemberPermissionFail
  } = actionCreators

  return (dispatch: any) => {
    dispatch(fetchTeamMemberPermissionRequest())
    return teamMemberPermissionService.fetchById(id).then(
      teamMemberPermission => {
        dispatch(fetchTeamMemberPermissionSuccess(teamMemberPermission))
      },
      error => {
        dispatch(fetchTeamMemberPermissionFail(error))
      }
    )
  }
}

export function updateTeamMemberPermission(teamMemberPermission: IUpdateTeamMemberPermissionDTO) {
  const {
    updateTeamMemberPermissionRequest,
    updateTeamMemberPermissionSuccess,
    updateTeamMemberPermissionFail
  } = actionCreators

  return (dispatch: any) => {
    dispatch(updateTeamMemberPermissionRequest())
    return teamMemberPermissionService.update(teamMemberPermission).then(
      () => {
        dispatch(updateTeamMemberPermissionSuccess(true))
      },
      error => {
        dispatch(updateTeamMemberPermissionFail(error))
      }
    )
  }
}

export function createTeamMemberPermission(teamMemberPermission: ICreateTeamMemberPermissionDTO) {
  const {
    createTeamMemberPermissionRequest,
    createTeamMemberPermissionSuccess,
    createTeamMemberPermissionFail
  } = actionCreators

  return (dispatch: any) => {
    dispatch(createTeamMemberPermissionRequest())
    return teamMemberPermissionService.create(teamMemberPermission).then(
      teamMemberPermission => {
        dispatch(createTeamMemberPermissionSuccess(teamMemberPermission))
      },
      error => {
        dispatch(createTeamMemberPermissionFail(error))
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/team-member-permission/index.ts